export const BRAND = {
  name: "Raj Home Massage",
  tagline: "RELAX • REJUVENATE • HEAL - WITH RAJ",
  phone: "+91 9702424106",
  phoneHref: "tel:+919702424106",
  whatsappHref: "https://wa.me/919702424106",
  whatsappBookingHref:
    "https://wa.me/919702424106?text=Hi%20Raj%2C%20I%27d%20like%20to%20book%20a%20massage%20session.",
  instagramHref: "https://www.instagram.com/massage_by_raj?igsh=eHB0cHd2eXF5dDBq",
  instagramHandle: "@massage_by_raj",
  twitterHref: "https://x.com/raj_therapist",
  googleBusinessHref: "https://share.google/AceIsYDw79w5bjB7Q",
  redditHref: "https://www.reddit.com/u/RajHomeWellness/s/zoalfcOr9c",
  address:
    "Shop No 9, Prathmesh Complex, Near Country Club, Veera Desai Road, Andheri West - 400053, Mumbai, Maharashtra",
  timing: "07:00 AM - 11:00 PM",
  couplesNote:
    "For couple bookings, feel free to reach out for flexible timing arrangements.",
  rating: 4.9,
  reviewCount: 124,
  logoUrl:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/2ewstwuq_LOGO.png",
  aboutPortraitUrl:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/xkc5o3ce_WhatsApp%20Image%202026-08-13%20at%2016.04.17.jpeg",
  canonicalUrl: "https://rajhomemassage.com",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Areas", href: "#areas" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export const HERO_TAGLINE_LINES = [
  "Personalized Massage Therapy by Raj",
  "Professional Care • Personal Touch",
  "Men & Women • Couple Friendly",
  "Home • Hotel • Massage Centre",
];

export const HERO_LOCATION_LINE = "Andheri West & East, Mumbai | Close to Mumbai Airport";

export const HERO_BODY =
  "I'm Raj, a certified male massage therapist with 15+ years of experience, offering professional massage therapy in Andheri West, just 15 minutes from Mumbai International Airport. I provide a clean, safe, and hygienic massage experience for men, women, and couples at home, hotels, and massage centres. My focus is on pain relief, stress release, deep relaxation, and complete body wellness.";

export const THERAPIST_ASSIGNMENT = [
  "Male Clients - personally attended by Raj.",
  "Female Clients - personally attended by Raj.",
  "Couple Massage - Raj can personally provide the massage for the couple.",
  "Couple Request for Male + Female Therapists - Raj can arrange a professional female therapist for the female partner, subject to prior appointment and availability.",
  "Four Hand Massage - available with Raj and a professional female therapist by prior appointment and subject to availability.",
];

export const SERVICES = [
  {
    id: 1,
    name: "Premium Full Body Massage",
    price: "₹6,000",
    desc: "A deeply relaxing massage using warm oils and balanced pressure. Helps release daily stress and promotes complete physical and mental relaxation.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/etoywghu_1.%20Premium%20Full%20Body%20Massage.jpeg",
    alt: "Raj performing a premium full body oil massage in a candlelit hotel room",
  },
  {
    id: 2,
    name: "Couple Massage",
    price: "₹10,000",
    priceFixed: true,
    desc: "A relaxing full body massage experience designed for two people to enjoy together in the same room. Performed by male and female therapists, ideal for couples, partners, friends, or family who wish to unwind together at home or in select hotels.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/wcn1atz7_2.%20Couple%20Massage%20%28Raj%20%2B%20female%20masseur%29.jpeg",
    alt: "Raj and a female masseur performing a side by side couple massage",
  },
  {
    id: 3,
    name: "Signature Massage - By Raj",
    price: "₹5,000",
    desc: "An exclusive slow-flow therapeutic bodywork technique developed over years of experience. Combines relaxation with therapeutic pressure for long-lasting relief and balance.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/wci6hs9f_3.%20Signature%20Massage%20-%20By%20Raj%20%28Raj%20visible%29.jpeg",
    alt: "Raj performing his signature therapeutic massage technique",
  },
  {
    id: 4,
    name: "Swedish Holistic Massage",
    price: "₹5,000",
    desc: "A gentle and flowing full body massage focused on relaxation and mind-body harmony. Improves blood circulation and reduces stress.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/sxev18it_4.%20Swedish%20Holistic%20Massage%20%28Raj%20visible%29.jpeg",
    alt: "Raj performing a gentle flowing Swedish holistic massage",
  },
  {
    id: 5,
    name: "Lomi Lomi Massage",
    price: "₹4,000",
    desc: "A traditional Hawaiian full body massage known for long, flowing, rhythmic strokes performed using hands and forearms. Helps release deep tension, improve circulation, and promote emotional as well as physical relaxation.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/fjx31gcm_5.%20Lomi%20Lomi%20Massage%20%28Raj%20visible%29.jpeg",
    alt: "Raj performing rhythmic flowing strokes of a traditional Lomi Lomi massage",
  },
  {
    id: 6,
    name: "Deep Tissue Massage",
    price: "₹3,000",
    desc: "Targets deeper muscle layers to relieve stiffness, knots, and chronic pain. Ideal for back pain, neck pain, and posture-related tension.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/aq3vwets_6.%20Deep%20Tissue%20Massage%20%28Raj%20visible%29.webp",
    alt: "Raj performing deep tissue massage targeting deeper muscle layers",
  },
  {
    id: 7,
    name: "Sports Massage",
    price: "₹3,000",
    desc: "Focused massage to release muscle fatigue and improve recovery. Improves flexibility, mobility, and overall muscle performance.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/pg3ls22j_7.%20Sports%20Massage%20%28Raj%20visible%29.webp",
    alt: "Raj performing a sports recovery massage on an athlete",
  },
  {
    id: 8,
    name: "Trigger Point Therapy",
    price: "₹4,000",
    desc: "Targeted pressure applied to specific trigger points to release chronic tension and pain. Ideal for clients with persistent muscle knots or referred pain patterns.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/4lihzyg7_8.%20Trigger%20Point%20Therapy.jpeg",
    alt: "Therapist applying targeted trigger point pressure therapy",
  },
  {
    id: 9,
    name: "Balinese Full Body Massage",
    price: "₹5,000",
    desc: "A traditional massage combining deep pressure, rhythmic strokes, and gentle stretches. Promotes deep relaxation and restores energy balance.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/droiwwyu_9.%20Balinese%20Full%20Body%20Massage.jpeg",
    alt: "Traditional Balinese full body massage setting",
  },
  {
    id: 10,
    name: "Four Hand Massage",
    price: "₹12,000",
    desc: "A synchronized massage performed by two therapists at once, offering double the relaxation and faster full-body relief - a truly indulgent therapeutic experience.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/kfrjafd2_10.%20Four%20Hand%20Massage.webp",
    alt: "Two therapists performing a synchronized four hand massage",
  },
  {
    id: 11,
    name: "Barefoot Massage",
    price: "₹3,000",
    desc: "A deep therapeutic massage where controlled pressure is applied using the therapist's feet along with balance support. Provides broad, even pressure to release deep muscle tension and promote full-body relaxation.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/84y5obej_11.%20Barefoot%20Massage%20%28Raj%20visible%29.png",
    alt: "Barefoot massage technique providing deep even pressure",
  },
  {
    id: 12,
    name: "Bamboo Massage",
    price: "₹5,000",
    desc: "A therapeutic massage using warm bamboo sticks to apply deep, even pressure. Helps relieve muscle stiffness, improve circulation, and promote deep relaxation.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/iy2kffq6_12.%20Bamboo%20Massage.webp",
    alt: "Warm bamboo sticks used for a therapeutic bamboo massage",
  },
  {
    id: 13,
    name: "Anti-Cellulite / Firming Massage",
    price: "₹5,000",
    desc: "A targeted massage to improve circulation and skin tone. Helps support body firming and contouring with regular sessions.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/zgemykbj_ChatGPT%20Image%20Aug%2017%2C%202026%2C%2001_06_43%20PM.png",
    alt: "Raj performing anti-cellulite firming massage on a client",
  },
  {
    id: 14,
    name: "Lymphatic Drainage Massage",
    price: "₹6,000",
    desc: "A gentle therapeutic massage designed to stimulate the lymphatic system and improve natural detoxification. Ideal for detox support, post-travel swelling, water retention, and overall wellness.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/lmcla2g9_14.%20Lymphatic%20Drainage%20Massage.webp",
    alt: "Gentle hand technique used in lymphatic drainage massage",
  },
  {
    id: 15,
    name: "Hotel Massage for Travelers",
    price: "₹8,000",
    desc: "Convenient in-room massage service for hotel guests and travelers near Mumbai Airport. Unwind after a long flight with a relaxing, hygienic massage in the comfort of your hotel room.",
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_wellness-by-raj/artifacts/8qyzjf3e_15.%20Hotel%20Massage%20for%20Travelers.webp",
    alt: "Raj performing in-room hotel massage for travelers near Mumbai Airport",
  },
];

export const SERVICE_PRICE_LABEL = "Starting From ₹3,000";

export const TRUST_SIGNALS = [
  { title: "15+ Years Certified Experience", icon: "Award" },
  { title: "Clean, Safe & Hygienic", icon: "ShieldCheck" },
  { title: "Home, Hotel & Massage Centre", icon: "Building2" },
  { title: "Andheri West - 15 mins from Mumbai Airport", icon: "PlaneTakeoff" },
  { title: "Trusted by 15,000+ Clients", icon: "Users" },
  { title: "Male, Female & Couples Welcome", icon: "HeartHandshake" },
  { title: "Specialist in Pain Relief & Relaxation", icon: "Sparkles" },
];

export const SERVICE_AREAS = {
  primary: [
    "Andheri West",
    "Lokhandwala Complex",
    "Versova",
    "Juhu",
    "Andheri East",
    "Bandra",
    "Marol",
    "Goregaon",
    "Powai",
  ],
  southMumbai: ["Colaba", "Cuffe Parade", "Fort", "Marine Drive", "Lower Parel", "Worli"],
};

export const TESTIMONIALS = [
  {
    name: "Amit S.",
    text: "Extremely professional and hygienic service. Raj's deep tissue massage completely relieved my back pain. Highly recommended!",
  },
  {
    name: "Priya & Nikhil",
    text: "Booked the couple massage for our anniversary at home. Punctual, respectful, and truly relaxing experience for both of us.",
  },
  {
    name: "Farhan K.",
    text: "I travel frequently for work and the hotel massage near the airport was a lifesaver after a long flight. Will book again.",
  },
];


export const REVIEWS = [
  {
    name: "Sukhbinder Kaur",
    rating: 5,
    timeAgo: "2 months ago",
    text: "I have been having massage sessions with Raj which has helped greatly with pain and stiffness in my legs, knees and feet. Raj is very experienced in identifying the source of the problem. At my last session I also had a facial and head massage which was very relaxing. Thank you Raj.",
  },
  {
    name: "Shreedhar Mishra",
    rating: 5,
    timeAgo: "4 months ago",
    text: "Had a great experience with Raj. Home service was smooth and comfortable. Good pressure and clean setup.",
  },
  {
    name: "Shahanawaz Khan",
    rating: 5,
    timeAgo: "1 year ago",
    text: "I recently booked a session with Raj from Raj Home Massage, and I must say it was one of the best decisions for my stiff neck pain. He is extremely professional, knowledgeable, and skilled in his technique.",
  },
  {
    name: "Sanket Kulkarni",
    rating: 5,
    timeAgo: "1 year ago",
    text: "Raj is fantastic with his work! He has a great understanding of the pressure, body type and techniques. He mixes up techniques across various massage types to customize an experience.",
  },
  {
    name: "Partha Banerjee",
    rating: 5,
    timeAgo: "7 months ago",
    text: "Very polite, professional and knowledgeable, will keep you engaged through the session. Recommended. God Bless.",
  },
  {
    name: "Shreyas Jain",
    rating: 5,
    timeAgo: "2 years ago",
    text: "Raj is one of the very few therapists that actually know what they're doing. He is professional, punctual and amazing at giving a relaxing massage. I've been suffering from acute neck and back pain since over a decade.",
  },
  {
    name: "Satty Vlogs",
    rating: 5,
    timeAgo: "1 year ago",
    text: "I was thoroughly impressed by the personalised attention. The therapist took the time to understand my specific needs and tailored the session accordingly, which made a huge difference. The massage itself was a perfect blend of technique and pressure, leaving me feeling rejuvenated and tension-free. I highly recommend this centre for anyone looking for a personalised, high-quality massage service!",
  },
  {
    name: "Elephant GoGo",
    rating: 5,
    timeAgo: "1 year ago",
    text: "I'm from Taiwan! The massage I got this time was amazing! And they even come to my hotel to do it!! Highly recommend!",
  },
  {
    name: "Mritunjay Pathak",
    rating: 5,
    timeAgo: "1 year ago",
    text: "Raj is a great therapist. He is meticulous and skilled.",
  },
  {
    name: "Vanishah Soobhug",
    rating: 5,
    timeAgo: "1 year ago",
    text: "Thank you sir there is magic in your hands - had a headache I thought I wouldn't be able to make my flight but magic happened instantly. Feel so blessed and grateful to have met you. My husband has become your fan. Highly recommend your service from Mauritius - looking forward to meeting you soon.",
  },
  {
    name: "Shiva Kasyap",
    rating: 5,
    timeAgo: "1 year ago",
    text: "Highly Professional Massage, Best Therapist in Mumbai",
  },
];

export const FAQ_ITEMS = [
  {
    q: "Do you offer home massage in Mumbai?",
    a: "Yes, Raj provides professional home massage across Andheri West, Andheri East, Juhu, Bandra, Goregaon, Powai and nearby areas by appointment.",
  },
  {
    q: "Is a female therapist available?",
    a: "A professional female therapist is available on explicit client request, subject to prior appointment and availability.",
  },
  {
    q: "Do you offer couple massage?",
    a: "Yes, couple massage is available at home, hotel and massage centre. Raj personally attends the session.",
  },
  {
    q: "What areas do you cover in Mumbai?",
    a: "Primary areas include Andheri West, Andheri East, Lokhandwala, Juhu, Versova, Bandra, Marol, Goregaon and Powai. South Mumbai on appointment.",
  },
  {
    q: "What are your timings?",
    a: "07:00 AM to 11:00 PM. For couple bookings, flexible timing is available on request.",
  },
  {
    q: "How do I book an appointment?",
    a: "Call or WhatsApp Raj directly on +91 9702424106 to confirm your preferred service, location, and time.",
  },
  {
    q: "Does Raj bring the massage table, sheets and oils for home visits?",
    a: "Yes, all equipment and supplies are brought to your location for home and hotel appointments.",
  },
  {
    q: "Is there a travel fee outside Andheri?",
    a: "Please contact Raj directly for travel arrangements and pricing for areas outside the primary service zone.",
  },
  {
    q: "What payment methods are accepted?",
    a: "Please contact Raj directly to confirm accepted payment methods.",
  },
  {
    q: "Are hotel appointments subject to hotel permission?",
    a: "Yes, hotel massage appointments are subject to hotel guest permission and availability.",
  },
];
